export default "__VITE_ASSET__CGifjZhE__"